import React from 'react';
import './Eyebrow.scss';
const Eyebrow: React.FC<
	React.PropsWithChildren<{ icon: string; tag: string; className?: 'large' }>
> = ({ icon, tag, className = '' }) => (
	<div className={['blk-ac-eyebrow-component', className].join(' ').trim()}>
		{icon && <i className={`eyebrow-icon ${icon}`}></i>}
		<span className="eyebrow-text">{tag}</span>
	</div>
);

export default Eyebrow;
